import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import { Tabs, Tab, Dialog, DialogContent, IconButton, Button } from '@material-ui/core';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import { useDataProvider, Loading, useTranslate, usePermissions } from 'react-admin';
import { Close, } from '@material-ui/icons'
import IconRadiusButton from '../CustomizedUIs/IconRadiusButton'
import General from './General';
import ChannelList from './ChannelList';
import InfoChannels from './InfoChannels';
import { DialogHeader, DialogAction, CustomDialogContent } from './InfoChannelDetail';
import { DialogHeaderService, DialogActionService, DialogContentService } from '../ExternalService/UseIn';
import imageInfo from '../assets/infochanges.png';
import ListDevices from '../devices';
import Settings from '../settings'
import CloseButton from '../CustomizedUIs/CloseButton';
import ExternalService from '../ExternalService/list'
import { LoadingButton } from '../common/button';

const useStyles = makeStyles(theme => ({
  selected: {
    backgroundColor: theme.tab.selectedColor,
    fontFamily: 'UniviaPro-Bold',
    fontSize: '11px',
    fontWeight: 'bold',
    fontStretch: 'normal',
    fontStyle: 'normal',
    lineHeight: 'normal',
    letterSpacing: ' 0.44px',
    color: '#ffffff !important',
  },
  indicator: {
    backgroundColor: '#ffffff',
    height: 5

  },
  tabRoot: {
    width: 155,
    height: 60,
    fontFamily: 'UniviaPro-Bold',
    fontSize: '11px',
    fontWeight: 'bold',
    fontStretch: 'normal',
    fontStyle: 'normal',
    lineHeight: 'normal',
    letterSpacing: ' 0.44px',
    color: 'rgba(255, 255, 255, 0.7)',
  },
  dialogPaper: {
    minHeight: '90vh',
    maxHeight: '90vh',
    backgroundColor: theme.palette.background.default
  },
  textClose: {
    fontFamily: 'UniviaPro-Bold',
    fontSize: '10px',
    fontWeight: 'bold',
    fontStretch: 'normal',
    fontStyle: 'normal',
    lineHeight: 'normal',
    letterSpacing: ' 0.4px',
    color: '#4f5064',
  },
  btnClose: {
    width: '28px',
    height: '28px',
    border: 'solid 2px #e5f1f8',
    backgroundColor: '#ffffff',
    padding: 0
  },
  TitleCluster: {
    fontFamily: 'UniviaPro-Medium',
    fontSize: '18px',
    fontWeight: 500,
    fontStretch: 'normal',
    fontStyle: 'normal',
    lineHeight: 1.2,
    letterSpacing: 'normal',
    color: '#4f5064',
  },
  borderClose: {
    width: '25px',
    height: '25px',
    border: 'solid 2px #e5f1f8',
    backgroundColor: '#ffffff',
    marginLeft: '10px'
  },
  titleUnSave: {
    fontFamily: 'UniviaPro-Book',
    fontSize: '22px',
    fontWeight: 'normal',
    fontStretch: 'normal',
    fontStyle: 'normal',
    lineHeight: 1.25,
    letterSpacing: 'normal',
    color: 'rgba(0, 0, 0, 0.87)',
  },
  contentUnSave: {
    fontFamily: 'UniviaPro-Book',
    fontSize: '12px',
    fontWeight: 'normal',
    fontStretch: 'normal',
    fontStyle: 'normal',
    lineHeight: 1.25,
    letterSpacing: 'normal',
    color: 'rgba(0, 0, 0, 0.87)',
    paddingTop: '10px'
  },
}));

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <Typography
      component="div"
      role="tabpanel"
      hidden={value !== index}
      id={`full-width-tabpanel-${index}`}
      aria-labelledby={`full-width-tab-${index}`}
      {...other}
    >
      {value === index && <Box display='flex' justifyContent='center' p={3}>{children}</Box>}
    </Typography>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

function a11yProps(index) {
  return {
    id: `full-width-tab-${index}`,
    'aria-controls': `full-width-tabpanel-${index}`,
  };
}


const EditClusterDialog = ({ tabIndex, isChange, setIsChange, readOnly, setDeleted, open,
  handleClose, dataRecever, clusterData, setEditData, openDialogAlert, setOpenDialogAlert,
  setIsCloseEdit, isCloseEdit, ...props }) => {
  const dataProvider = useDataProvider();
  const translate = useTranslate();
  const classes = useStyles()
  const theme = useTheme();
  const [value, setValue] = React.useState(0);
  const { permissions, loaded } = usePermissions();
  const [success, setSuccess] = React.useState(false)
  const [loading, setLoading] = React.useState(true)
  const [isSave, setIsSave] = React.useState(false)
  const [rooms, setRooms] = React.useState()
  const [newValue, setNewValue] = React.useState(1);
  const [openDetailInfoChannel, setOpenDetailInfoChannel] = React.useState({
    status: false,
    data: null
  })

  const [openDetailService, setOpenDetailService] = React.useState({
    status: false,
    data: null
  })


  const handleChange = (event, newValue) => {
    if (value === 1 && isChange) {
      setOpenDialogAlert(true)
      setNewValue(newValue)
    }
    else
      setValue(newValue);
  };

  const handleChangeIndex = (index) => {
    setValue(index);
  };

  const getRooms = () => {
    setLoading(true)
    dataProvider('CREATE', "infochannels/getroom", {
      data: {
        clusterId: clusterData.id,
        infoChannel: openDetailInfoChannel.data.id
      }
    })
      .then(({ data }) => {
        data.map(item => {
          item.infoChannel = openDetailInfoChannel.data.id
          return item
        })
        setRooms(data)
        setLoading(false)

      })
      .catch(() => {
        setLoading(false)
      })
  }

  const getRoomsForService = () => {

    dataProvider('CREATE', "services/getroom", {
      data: {
        clusterId: clusterData.id,
        service: openDetailService.data.id
      }
    })
      .then(({ data }) => {
        setRooms(data)
        setLoading(false)

      })
      .catch(() => {
        setLoading(false)
      })
  }

  const handleCancelDialog = () => {
    if (isCloseEdit === true && newValue === 1) {
      setIsCloseEdit(false)
    }
    setOpenDialogAlert(false)
    setValue(newValue)
    setNewValue(1)
    setIsChange(false)
  }
  const handleCloseDialogAlert = () => {
    setOpenDialogAlert(false)
    setNewValue(1)
  }
  const onSave = () => {
    setOpenDialogAlert(false)
    setIsSave(true)
    setIsChange(false)
  }


  React.useEffect(() => {
    setOpenDetailInfoChannel({
      status: false,
      data: null
    })
    setOpenDetailService({
      status: false,
      data: null
    })
    setRooms(null)
    setValue(!tabIndex ? 0 : tabIndex)
  }, [open]);

  React.useEffect(() => {
    if (!openDetailService.status && !openDetailInfoChannel.status)
      setLoading(true)

  }, [openDetailInfoChannel, openDetailService]);
  if (!loaded) return <Loading />

  return (
    <Dialog
      open={open}
      aria-labelledby="form-dialog-title"
      scroll='paper'
      classes={{ paper: classes.dialogPaper }}
      fullWidth={true}
      maxWidth='lg'>
      <Dialog open={openDialogAlert} onClose={handleCloseDialogAlert} aria-labelledby="form-dialog-title" classes={{
        paper: classes.paper
      }} >
        <Box className={classes.container}>
          <Box display='flex' justifyContent='flex-end' alignItems='center' mr={2} pt={1}>
            <Typography className={classes.textClose}>{translate(`pos.common.close`)}</Typography>
            <IconButton className={classes.BorderClose} onClick={handleCloseDialogAlert} >
              <Close color='primary' />
            </IconButton>
          </Box>
          <img alt='image-save' src={imageInfo} className={classes.image} />
          <Typography className={classes.titleUnSave}>{translate('resources.role.titleUnsave')}</Typography>
          <Typography className={classes.contentUnSave}>{translate('resources.role.contentUnsave')}</Typography>

          <Box mt={3}>
            <Button
              style={{ marginTop: 16, marginRight: 20 }}
              onClick={handleCancelDialog}
            >
              <Typography className={classes.btnCancel}>{translate(`pos.dashboard.CANCEL`)}</Typography>
            </Button>
            <LoadingButton
              label={translate(`resources.role.Save`)}
              onClick={onSave}
            />
          </Box>
        </Box>
      </Dialog>
      {
        openDetailInfoChannel.status ?
          <DialogHeader success={success} setSuccess={setSuccess} data={openDetailInfoChannel.data} loading={loading} handleClose={handleClose} setOpenDetail={setOpenDetailInfoChannel}></DialogHeader>
          :
          openDetailService.status ?
            <DialogHeaderService success={success} setSuccess={setSuccess} data={openDetailService.data} loading={loading} handleClose={handleClose} setOpenDetail={setOpenDetailService} />
            :
            (
              <Box mt={3}>
                <Box mb={3} ml={4} display='flex'>
                  <Box flexGrow={1} display='flex' alignItems='flex-end'>
                    <Typography className={classes.TitleCluster}>{translate(`resources.room.updating`) + " " + clusterData.name}</Typography>
                  </Box>
                  <Box display='flex' justifyContent='flex-end' alignContent='center' mr={3}>
                    <Typography style={{ margin: 'auto 8px auto 0' }} className={classes.textClose}>  {translate(`pos.dashboard.close`)}</Typography>
                    <CloseButton onClick={handleClose} />
                  </Box>
                </Box>

                <AppBar position="static">
                  <Tabs
                    className={classes.TextTitle}
                    value={value}
                    onChange={handleChange}
                    classes={{
                      indicator: classes.indicator
                    }}
                    centered
                  >
                    <Tab classes={{ root: classes.tabRoot, selected: classes.selected }} label={translate(`resources.room.general`)}{...a11yProps(0)} />
                    <Tab disabled={!permissions.functionAction.find(value => value.function === 'Cluster settings' && value.isRead)
                      && !permissions.functionAction.find(value => value.function === 'Cluster info page settings' && value.isRead)}
                      classes={{ root: classes.tabRoot, selected: classes.selected }} label={translate(`resources.room.settings`)} {...a11yProps(1)} />
                    <Tab classes={{ root: classes.tabRoot, selected: classes.selected }} label={translate(`resources.room.externalService`)} {...a11yProps(2)} />
                    <Tab disabled={!permissions.functionAction.find(value => value.function === 'Cluster channel admin' && value.isRead)}
                      classes={{ root: classes.tabRoot, selected: classes.selected }} label={translate(`resources.room.channelLists`)} {...a11yProps(3)} />
                    <Tab disabled={!permissions.functionAction.find(value => value.function === 'Cluster Info Channel Admin' && value.isRead)}
                      classes={{ root: classes.tabRoot, selected: classes.selected }} label={translate(`resources.room.infoChannels`)} {...a11yProps(4)} />
                    <Tab classes={{ root: classes.tabRoot, selected: classes.selected }} label={translate(`resources.room.deviceFirmwareUpdate`)} {...a11yProps(5)} />
                  </Tabs>
                </AppBar>
              </Box>

            )
      }

      {
        openDetailInfoChannel.status ? <CustomDialogContent getList={getRooms} loading={loading} data={openDetailInfoChannel.data} rooms={rooms} setRooms={setRooms}></CustomDialogContent>
          :
          openDetailService.status ? <DialogContentService getList={getRoomsForService} loading={loading} setLoading={setLoading} data={openDetailService.data} rooms={rooms} setRooms={setRooms} />
            :
            (
              <DialogContent dividers={false} id='containerClusterEditDialog'>
                <TabPanel value={value} index={0} dir={theme.direction}>
                  <General
                    {...props}
                    open={open}
                    readOnly={readOnly}
                    setDeleted={setDeleted}
                    handleClose={handleClose}
                    dataRecever={dataRecever}
                    clusterData={clusterData}
                  />
                </TabPanel>
                <TabPanel value={value} index={1} dir={theme.direction}>
                  <Settings cluster={clusterData.id} isSave={isSave} setIsSave={setIsSave} isChange={isChange} clusterData={clusterData} setEditData={setEditData}
                    setIsChange={setIsChange} setValue={setValue} newValue={newValue} infoPageId={clusterData.infopage} />
                </TabPanel>
                <TabPanel value={value} index={2} dir={theme.direction}>
                  <ExternalService inCluster={true} cluster={clusterData} openDetailService={openDetailService} setOpenDetail={setOpenDetailService} />
                </TabPanel>
                <TabPanel value={value} index={3} dir={theme.direction}>
                  <ChannelList
                    from='cluster'
                    data={clusterData}
                    permissions={permissions}
                  />
                </TabPanel>
                <TabPanel value={value} index={4} dir={theme.direction}>
                  <InfoChannels permissions={permissions} openDetailInfoChannel={openDetailInfoChannel} setOpenDetail={setOpenDetailInfoChannel} clusterData={clusterData}></InfoChannels>
                </TabPanel>
                <TabPanel value={value} index={5} dir={theme.direction}>
                  <ListDevices selectedClusterData={clusterData} {...props} />
                </TabPanel>
              </DialogContent>
            )
      }
      {
        openDetailInfoChannel.status ? <DialogAction setSuccess={setSuccess} loading={loading} rooms={rooms} setRooms={setRooms} data={openDetailInfoChannel.data} setOpenDetailInfoChannel={setOpenDetailInfoChannel}></DialogAction>
          : openDetailService.status ? <DialogActionService setSuccess={setSuccess} loading={loading} rooms={rooms} setRooms={setRooms} data={openDetailService.data} setOpenDetailService={setOpenDetailService} /> : null
      }


    </Dialog>

  );
}
export default EditClusterDialog